import React from 'react';
export default function Blockquote(props) {
  return /*#__PURE__*/React.createElement("blockquote", null, props.children);
}